const BASE_URL = process.env.REACT_APP_API_URL || '';

export const ENDPOINTS = {
  arribos: `${BASE_URL}/api/arribos`,
  unionplatense: `${BASE_URL}/api/arribos/unionplatense`,
  linea7: `${BASE_URL}/api/arribos/linea7`
};
